/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EGender } from "../types/EGender.ts";

/**
 * @description 1 = Male | 2 = Female | 3 = IDontWantToAnswer |
 */
export const eGenderSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Male | 2 = Female | 3 = IDontWantToAnswer | ",
  ) as unknown as ToZod<EGender>;
